"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.76,0H2.24a.56.56,0,0,0-.63.64V20.15a.56.56,0,0,0,.63.64H8.63l3.21,3.15a.24.24,0,0,0,.32,0l3.21-3.15h6.39a.56.56,0,0,0,.63-.64V.64A.56.56,0,0,0,21.76,0Z",
    style: {
      fill: '#004864'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.17,17A.13.13,0,0,1,7,16.84V16.3a.13.13,0,0,1,.13-.13H7.9A.13.13,0,0,0,8,16v-.29a.13.13,0,0,1,.13-.13H9.48a.13.13,0,0,1,.13.13v.33a.13.13,0,0,0,.13.13h1.89a.13.13,0,0,0,.14-.13v-.32a.13.13,0,0,1,.13-.13h8.18a.13.13,0,0,1,.13.13v.37a.13.13,0,0,1-.13.13s-3,0-4.17.2a4.28,4.28,0,0,0-1.59.44.51.51,0,0,1-.24.07Z",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.8,14.94a.13.13,0,0,0,.13.13h3a.13.13,0,0,0,.13-.13V12.28a.21.21,0,0,0-.12-.18l-.11,0a9.71,9.71,0,0,1-2.93-2.58c0-.05-.07,0-.07,0v5.44Z",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.62,12.39a.09.09,0,0,0-.13.09v2.46a.13.13,0,0,0,.13.13h1.19l.24,0,.06,0,.06,0V13a.15.15,0,0,0-.13-.14l-1.42-.46Z",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.84,9.39a.09.09,0,0,1-.09-.12l.62-2a.18.18,0,0,1,.17-.13h4.33A.16.16,0,0,1,13,7.3l.38,2a.09.09,0,0,1-.1.12Zm4.53,3.35a.52.52,0,1,1,.51-.51.51.51,0,0,1-.51.51Zm-4,0a.52.52,0,1,1,.51-.51.51.51,0,0,1-.51.51Zm6-4a.75.75,0,0,0-.05-.26,10.48,10.48,0,0,0-.76-1.56,1.1,1.1,0,0,0-.73-.42H8.49c-.14,0-.23.15-.35.31s-.79,2.27-.86,2.56-.15.77-.15.77a2.28,2.28,0,0,0,0,.26L7,12.83v.73c0,.22,0,.26.39.92s.76.61.76.61l.26,0H14.2a.13.13,0,0,0,.13-.13V8.74Z",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.17,5.61a.27.27,0,0,1-.12,0L12,2.29,4,5.58a.31.31,0,0,1-.39-.13.27.27,0,0,1,.15-.36l8.16-3.34a.33.33,0,0,1,.24,0l8.18,3.34a.27.27,0,0,1,.15.36A.3.3,0,0,1,20.17,5.61Z",
    style: {
      fill: '#fff',
      stroke: '#fff',
      strokeMiterlimit: 10,
      strokeWidth: '0.5px'
    }
  }));
};

exports["default"] = _default;